
import * as React from "react";
import Attachment from "../../_data/models/Attachment";
import OwlCarousel from 'react-owl-carousel';
import {imageAspectSizeForMaxHeight} from "../../_helpers/imageHelpers";



interface Props {
    images: Attachment[]
}

const CarouselComponent = (props: Props) => {

    const {images} = props;

    return (
        <OwlCarousel
            className="owl-theme"
            loop={images.length > 1}
            margin={0}
            autoWidth={true}
            items={1}
            nav={false}
            dots={true}
            center={true}
        >
            {images.map((each: Attachment) => {

                let width: number = each.width*.4;

                let adjustedSize = imageAspectSizeForMaxHeight(each, {height: 360, width: 480});

                // console.log("Original size: "+each.width+"x"+each.height);
                // console.log("Adjusted size: "+adjustedSize.width+"x"+adjustedSize.height);
                // console.log("================================");

                return (
                    <div style={{width: adjustedSize.width, height:adjustedSize.height} } key={"carousel_item_"+each.id}>
                        <img src={each.url} />
                    </div>
                );

            })}
        </OwlCarousel>
    );
};

export default CarouselComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/carousel/CarouselComponent.tsx